import FJAIAudioLeftContainer from './FJAIAudioLeft/container/FJAIAudioLeftContainer.jsx';
import FJAIAudioRightContainer from './FJAIAudioRight/container/FJAIAudioRightContainer.jsx';
import FJAIAudioGeneratorData from '../../config/dataConfig/FJAIAudioGeneratorData';
import FJNavBar from '../../common/components/FJNavBar/FJNavBar.jsx';
import { useDispatch, useSelector } from 'react-redux';
import FJActionAIAudioGenerator from '../../redux/action/FJActionAIAudioGenerator.js';
import FJAudioPlayManager from '../../store/FJAudioPlayManager.js';
import { useCallback } from 'react';
import { setSliceSelectListAction } from '../../redux/slices/FJSliceCommon.js';
import useLocalStore from '../../hooks/useLocalStore.js';

const MENU_LIST = FJAIAudioGeneratorData.MENU_LIST;

const FJAIAudio = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.AIAudioGenerator.tabIndex);

    const onChangeTabIndex = useCallback(
        value => {
            FJAudioPlayManager.pauseAll();
            const index = MENU_LIST.findIndex(item => item.value === value);
            dispatch(FJActionAIAudioGenerator.changeTabIndexAction(index));
            dispatch(FJActionAIAudioGenerator.setHistoryTabIndexAction(index + 1));
            dispatch(setSliceSelectListAction([]));
            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(false));
        },
        [dispatch],
    );

    const selectTab = MENU_LIST[tabIndex].value;

    return (
        <>
            <FJNavBar tabList={MENU_LIST} onChangeTab={onChangeTabIndex} selectTab={selectTab} isMusicNav={true} />
            <FJAIAudioLeftContainer />
            <FJAIAudioRightContainer />
        </>
    );
};

export default FJAIAudio;
